export class CalendarEvent {
    constructor() {
        this.name = '';
        this.start = '';
        this.end = '';
        this.color = 'primary';
    }
    CalendarEvent() { }
}
